import envConfig from '../../../application/configurations/envConfig';
import { ApiConfig } from '../../../application/configurations/IConfig';

/**
 * class for creating api request with configuration passed to this class
 */
export class ApiRequest {
  private baseUrl: string;

  //Setting default mode
  private mode?: RequestMode = 'cors';

  requestBody: Request;

  /**
   * constructor where we create a new window request with api config and headers
   * @param   {object} apiConfig configuration contains method,body and headers
   * @param   {object} headers   http headers
   */
  constructor(apiConfig: ApiConfig, headers: Headers) {
    /**
     * if api configuration contains base url then it set with same
     * or else its setting api base url from environment configuration
     */
    this.baseUrl = envConfig.apiBaseUrl;
    let apiUrl = apiConfig.baseUrl ? apiConfig.baseUrl : this.baseUrl;
    if (apiConfig.endpoint) {
      apiUrl += apiConfig.endpoint;
    }

    /**
     * if api configuration contains mode then set with same
     * or else its sets default mode
     */
    if (apiConfig.mode) {
      this.mode = apiConfig.mode;
    }

    /**
     * api payload data
     */
    const requestPayload = apiConfig.data
      ? JSON.stringify(apiConfig.data)
      : null;

    /**
     * creating request object with given api params
     */
    this.requestBody = new window.Request(apiUrl, {
      method: apiConfig.method,
      body: requestPayload,
      headers: headers,
      mode: this.mode
    });
  }
}
